import { useQuery } from '@tanstack/react-query'

// services
import API from '../services/api'

const getSample = async (sampleId) => {
    if (!sampleId) return null
    const { data } = await API.getSampleById(sampleId)
    return data
}

export default function useSampleQuery(sampleId) {
    return useQuery({
        queryKey: ['sample', parseInt(sampleId)],
        queryFn: () => getSample(sampleId),
    })
}
